import React, { Component } from 'react';
import ProfileComponent from '../../../../../../components/Profile';

/**
 * Profile screen, for showing profile form.
 *
 * @extends React.Component
 */
class Profile extends Component {
  render() {
    return (
      <ProfileComponent />
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Settings/screens/Profile/index.js